import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeSchool } from "../../../shared/store/redux/auth-actions";
import DropDown from "../../../shared/components/features/dropDown/DropDown";
import classes from './ChangeSchool.module.css'

const ChangeSchool = () => {

    const dispatch = useDispatch();

    const { texts } = useSelector((state) => state.translate);
    const { userDetails } = useSelector((state) => state.auth);

    const schools = useMemo(() => userDetails?.schools, [userDetails]);
    return (
        <DropDown
            value={userDetails?.defaultSchool?.name}
            optionClassName={classes.SchoolOption}
            hideSelectedInList={true}
            arrowColor={"#010101ff"}
            options={schools.map((school) => ({
                key: school.id,
                value: school.name,
                onClick: () => dispatch(changeSchool(school)),
            }))}
        />
    );
};

export default ChangeSchool;
